import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import HeroFinal from "../../../videos/hero-section.mp4";
import { ArrowRightAlt } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: "100vw",
    height: "100vh",
    backgroundColor: "#071f22",
  },
  mainPart: {
    height: "100%",
    width: "100%",
    color: theme.palette.text.hint,
  },
  pageTop: {
    display: "flex",
    height: `calc(60vh - 60px)`,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  smallLogo: {
    height: 23,
  },
  logoSlogan: {
    fontSize: 24,
    fontWeight: 800,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    color: "#ffffff",
  },
  logoBody: {
    fontSize: 16,
    fontWeight: 500,
    color: "#74e2a6",
  },
  buttonInfoToMore: {
    fontSize: 16,
    marginTop: theme.spacing(5),
    borderColor: theme.palette.text.hint,
    color: theme.palette.text.hint,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    borderRadius: 0,
    "&:hover": {
      color: "white",
      borderColor: "white",
    },
    textTransform: "Capitalize",
  },
  buttonInfoToDocs: {
    fontSize: 16,
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(5),
    borderColor: theme.palette.text.hint,
    color: theme.palette.text.hint,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    borderRadius: 0,
    "&:hover": {
      color: "white",
      borderColor: "white",
    },
    textTransform: "Capitalize",
  },
  buttonInfoToAssign: {
    color: theme.palette.text.hint,
    borderColor: theme.palette.text.hint,
    borderRadius: 0,
    "&:hover": {
      color: "white",
      borderColor: "white",
    },
    padding: "0 8px",
    textTransform: "Capitalize",
  },
  buttonInfoToData: {
    borderColor: "#ab42ff",
    borderRadius: 4,
    textTransform: "Capitalize",
    padding: "0 8px",
    color: theme.palette.text.hint,
    marginRight: theme.spacing(2),
  },
  mainTitle: {
    display: "flex",
    color: theme.palette.text.primary,
    justifyContent: "center",
  },
  bottomPart: {
    color: theme.palette.text.secondary,
    position: "absolute",
    bottom: 0,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    "& a": {
      color: theme.palette.text.hint,
      cursor: "pointer",
      textDecoration: "none",
    },
    zIndex: 100,
  },
}));

export default function Feature1() {
  const classes = useStyles();

  const defaultSystemName = "Biology Organized, Insights Amplified";
  const sloganBody = "Streamlining Biology Discovery with Data & Machine Learning Solutions."

  return (
    <div className={classes.root}>
      <Grid container className={classes.mainPart}>
        <Grid item xs={12} md={12}>
          <div className={classes.pageRight}>
            <video width={"100%"} loop={true} autoPlay={true} muted={true}>
              <source src={HeroFinal} />
            </video>
          </div>
        </Grid>
      </Grid>
      <Grid container className={classes.mainPart} style={{ position: "absolute", top: 0, left: 0 }}>
        <Grid item xs={12} md={12}>
          <div className={classes.pageTop}>
            <div>
              <p className={classes.logoSlogan} id="slogan">
                {defaultSystemName}
              </p>
            </div>
            <div>
              <p className={classes.logoBody}>
                {sloganBody}
              </p>
            </div>
            <div>
              <Button
                endIcon={<ArrowRightAlt />}
                variant={"outlined"}
                className={classes.buttonInfoToMore}
                onClick={() => window.open("https://megaai.data.labillion.cn", "_blank")}
              >
                Quick Start
              </Button>
              <Button
                endIcon={<ArrowRightAlt />}
                variant={"text"}
                className={classes.buttonInfoToDocs}
                onClick={() => window.open("https://docs.data.labillion.cn/scilab/", "_blank")}
              >
                Build AI
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
      <p className={classes.bottomPart}>The world's leading enterprises work with MegaRobo.
        <a href="https://en.megarobo.com/#page2" target="_blank">&nbsp;&nbsp;Meet our customers →</a>
      </p>
    </div>
  );
}